module.exports = __webpack_public_path__ + "static/media/heroRTY.5889cd5e.webp";